import { render, staticRenderFns } from "./AdminWorkOrder.vue?vue&type=template&id=50d4e928&scoped=true"
import script from "./AdminWorkOrder.vue?vue&type=script&lang=js"
export * from "./AdminWorkOrder.vue?vue&type=script&lang=js"
import style0 from "./AdminWorkOrder.vue?vue&type=style&index=0&id=50d4e928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d4e928",
  null
  
)

export default component.exports